module.exports = __webpack_public_path__ + "static/media/dontSpeak.09da19a7.png";